import { render } from "./MFileUploader.vue?vue&type=template&id=cddc182c"
import script from "./MFileUploader.vue?vue&type=script&lang=js"
export * from "./MFileUploader.vue?vue&type=script&lang=js"

import "./MFileUploader.vue?vue&type=style&index=0&id=cddc182c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__